export default "__VITE_ASSET__ad444365__"